import { useMemo } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

/**
 * Alle accounts met CMS-toegang: uitgenodigde CMS-accounts (`role` in
 * cmsAdmin/cmsUser/cmsSales, store `cmsUsers`) plus webshopaccounts die
 * CMS-toegang hebben gekregen (`cmsRole`, store `cmsLinkedUsers`). Beide
 * queries staan in App.js. Gebruik deze hook waar je "collega's" nodig hebt —
 * taaktoewijzing, auteur van een notitie, de gebruikerslijst in Beheer.
 */
export const useCmsUsers = () => {
  const cmsUsers = useSelector((state) => state.firestoreReducer.ordered.cmsUsers);
  const cmsLinkedUsers = useSelector((state) => state.firestoreReducer.ordered.cmsLinkedUsers);
  return useMemo(() => _.unionBy(cmsUsers || [], cmsLinkedUsers || [], "id"), [cmsUsers, cmsLinkedUsers]);
};

export default useCmsUsers;
